import i18n from '../../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../../core/components/input-widget/BaseModel";
import {LOT_NO_REGEX} from "@/plugins/vee-validate";

export default class TelephoneBidModel extends BaseModel {
  lot_no = null;
  cover_amount = null;

  static TRANSLATABLE_FIELDS = [];

  rules = {
    lot_no: {
      required: true,
      regex: LOT_NO_REGEX
    },
  };

  attributeLabels = {
    lot_no: i18n.t('Lot'),
    cover_amount: i18n.t('Cover Amount'),
  };

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
    this.initTranslatableFields(this);
  }
}

defineTranslatableProperties(TelephoneBidModel);
